"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementPartCategoryProperty = getElementPartCategoryProperty;
exports.isGroundElement = isGroundElement;
exports.isGroundTerminal = isGroundTerminal;
exports.getPinNumberProperty = getPinNumberProperty;
exports.getElementPartType = getElementPartType;
exports.elementMatchesPartType = elementMatchesPartType;
const constants_1 = require("@buildwithflux/constants");
const constants_2 = require("../part/constants");
const functions_1 = require("../part/functions");
function getProperty(propName, properties) {
    return Object.values(properties).find((prop) => prop.name === propName);
}
function getElementPartCategoryProperty(element) {
    const properties = element.properties ?? {};
    const propArray = Object.values(properties);
    return (propArray.find((prop) => prop.name === constants_1.defaultPropertyDefinitions.part_type.label) ||
        properties[constants_1.deprecatedPartCategoryPropertyKey]);
}
/**
 * Check if an element is type of Ground
 *
 * This methods checks the element's "Part Type" property and retrns true if its value is "Ground".
 *
 * Note that any Ground element has no pcb node associated with it.
 *
 * @param element - element to check
 */
function isGroundElement(element) {
    return getElementPartCategoryProperty(element)?.value === constants_1.partPropertyCategories.ground;
}
/**
 * Previously the element was determined to be a Ground if the designator (or label)
 * matched "GND". This was insufficient as non-Ground elements would incorrectly be
 * considered Grounds if for instance, the user gave that element a label value of "GND"
 */
function isGroundTerminal(element, terminalId) {
    return (element && isGroundElement(element)) || terminalId.includes(constants_2.GROUND_TERMINAL_UID);
}
function getPinNumberProperty(element) {
    return getProperty(constants_1.defaultPropertyDefinitions.pin_number.label, element.properties);
}
/**
 * Gets the Part Type property value from an element.
 *
 * @param element - The element to get the part type from
 * @returns The part type string, or undefined if not set
 */
function getElementPartType(element) {
    const properties = element.properties;
    if (!properties)
        return undefined;
    const partTypeLabel = constants_1.defaultPropertyDefinitions.part_type.label;
    const partTypeKey = constants_1.defaultPropertyDefinitions.part_type.key;
    for (const prop of Object.values(properties)) {
        if (prop && typeof prop === "object" && "name" in prop && prop.name === partTypeLabel) {
            const value = "value" in prop ? prop.value : undefined;
            return typeof value === "string" ? value : undefined;
        }
    }
    const oldFormatProp = properties[partTypeKey];
    if (typeof oldFormatProp === "string") {
        return oldFormatProp;
    }
    if (oldFormatProp && typeof oldFormatProp === "object" && "value" in oldFormatProp) {
        return typeof oldFormatProp.value === "string" ? oldFormatProp.value : undefined;
    }
    return undefined;
}
/**
 * Checks if an element's Part Type matches a target type.
 * Uses matchesPartType under the hood.
 *
 * @param element - The element to check
 * @param targetType - The part type to match (e.g. "Inductor", "Resistor")
 * @param options - Optional { includeParents } - defaults to true for hierarchy matching
 * @returns True if the element's part type matches targetType
 */
function elementMatchesPartType(element, targetType, options) {
    return (0, functions_1.matchesPartType)(getElementPartType(element), targetType, options);
}
//# sourceMappingURL=functions.js.map